module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AX3UXJ/tc-custom/9781685501273.jpg?1723407365979",
      "alt": "This image is the cover for the book Road to Nowhere"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Road to Nowhere\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stella is lost in the dark, driving in a storm on an increasingly narrow, unfamiliar country road. What should she do? And why is she running away?"), _c('br'), _c('br'), _vm._v("Stella’s car runs off the road and she injures her head. She needs help. Beyond the wild hedgerows and woods is a sprawling mansion with lights in the windows. It seems a party is taking place and Stella’s saved ... or is she?"), _c('br'), _c('br'), _vm._v("When Stella meets the host, the stunning Madame Reynard, she’s instantly attracted. In fact, she knows this woman ... intimately. How? Why is she so familiar?"), _c('br'), _c('br'), _vm._v("Stella searches for answers in this dark gothic tale of desire and denial.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mags Hayward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0